import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../MissionAndVission/MissioonSideCards/MissioonSideCards.css";
import "../../TravelArrangements/TravelArrangementsSideCards/TravelArrangementsSideCards.css";
import "./CTSideCards.css";
import Heading from "../../../utls/Heading";

const CTSideCards = () => {
  return (
    <>
      <div className="container card-container">
        <div className="row">
          <div className="safetyCardBox mt-5 pt-lg-5 mb-5 ms-lg-3 px-lg-5">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
              <Heading className="headings mt-3 ct-headings  ps-2 ps-md-0">
                <span>Business </span>Travel Solutions
              </Heading>
              <p className="missionP-one px-2 px-md-0">
                At Blueberry Travel, we recognize that corporate travel is not
                just about getting from point A to point B—it plays a crucial
                part in your organization’s growth, operations, and success.
                Whether it's sending employees to an important business meeting,
                hosting an international conference, or facilitating
                team-building retreats, we understand the significance of every
                detail. Our services are designed to simplify your travel
                management, reduce stress, and optimize your team’s time on the
                road.
              </p>
              <p className="missionP-two px-2 px-md-0">
                We deliver more than the basics of booking flights and
                accommodations. Our team of experts works closely with you to
                create a complete, customized travel plan that aligns with your
                company’s goals. From personalized itineraries and flexible
                schedules to cost-saving strategies and real-time updates, we
                ensure that each aspect of your corporate travel is managed with
                preciseness.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/traveler1.png"
                alt=""
                className="safetyTravelimg mission-images"
                loading="lazy"
              />
            </div>
          </div>

          <div className="safetyCardBoxReverse mb-5 pb-lg-4 pe-lg-5 me-lg-3">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
              <Heading className="headings mt-3 ct-headings ps-2 ps-md-0">
                <span>Your Companion</span> in Perfect Business Travel
              </Heading>
              <p className="missionP-one px-2 px-md-0">
                We focus on designing customized travel plans that acclimate to
                the various needs of commercial clients. From global conferences
                to important board meetings and team-building events, we take
                care of everything to ensure a smooth journey. Our assistance
                includes managing flight bookings, accommodation arrangements,
                ground transportation, and event logistics—all personalized to
                your specific schedule and preferences.
              </p>
              <p className="missionP-two px-2 px-md-0">
                Our dedicated team works closely with you to guarantee that
                every part of your trip is well-organized.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-xxl-4">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/traveler2.png"
                alt=""
                className="safetyTravelimg safetyTravelimg2 mission-images"
                loading="lazy"
              />
            </div>
          </div>

          <div className="safetyCardBox mb-5 px-lg-5 ms-lg-3 pb-lg-4">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
              <Heading className="headings mt-3 ct-headings ps-2 ps-md-0">
                <span>
                  On<b>-</b>Time<b>,</b>
                </span>{" "}
                On Budget<b>,</b>and Stress<b>-</b>Free Travel
              </Heading>
              <p className="missionP-one px-2 px-md-0">
                We understand that in the world of profit and growth, time is
                the core. Our crew is dedicated to ensuring that your team
                arrives at their destination on schedule, without unnecessary
                delays or disruptions. From timely flight bookings to efficient
                ground transport and accommodations, we make sure every part of
                your travel plan is executed perfectly.
              </p>
              <p className="missionP-two px-2 px-md-0">
                We’re also devoted to providing cost-effective resolutions,
                helping your business stay within its travel budget while still
                offering excellent services. At Blueberry Travel, you can rest
                assured that we will handle every detail, supplying your
                workforce with the support they need to make the most of their
                corporate trip.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/traveler3.png"
                alt=""
                className="safetyTravelimg mission-images"
                loading="lazy"
              />
            </div>
          </div>
          <div className="safetyCardBoxReverse ct-lastcard-mb pe-lg-5 me-lg-3 mb-5 pb-lg-5">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
              <Heading className="headings mt-3 ct-headings ps-2 ps-md-0">
                <span>Your Responsible Supporter</span> in Seamless Business
                Travel{" "}
              </Heading>
              <p className="missionP-one px-2 px-md-0">
                At Blueberry Travel, we understand the importance of
                trustworthy, efficient, and cost-effective corporate travel
                management. We are more than just a travel service
                provider—we’re your dedicated consultant, committed to improving
                your travel logistics to keep your business running smoothly.
                Whether it’s managing individual travel needs or scheduling
                group events, we ensure that your crew’s travel experience is
                smooth and seamless from start to finish.
              </p>
              <p className="missionP-two px-2 px-md-0">
                Our purpose is to deliver you a travel experience that helps
                your team stay productive, relaxed, and focused. By handling the
                complexities of business travel, we allow you to focus on
                achieving your strategic objectives while we manage the details.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-xxl-5">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/traveler4.png"
                alt=""
                className="safetyTravelimg safetyTravelimg2 mission-images"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CTSideCards;
